import produce from 'immer';

export const saveLayoutMonitoringSuccess = (actions, state) => {
  return produce(state, (draft) => {
    if (draft?.data?.settings) {
      draft.data.settings.campaignMonitoringLayout = JSON.stringify(actions?.nextColumns);
    }
  });
};

export const saveLayoutContactSuccess = (actions, state) => {
  return produce(state, (draft) => {
    if (draft?.data?.settings) {
      draft.data.settings.contactGroupLayout = JSON.stringify(actions?.nextColumns);
    }
  });
};

// regenerate api key
export const fetchRegenerateAPIKey = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRegenerateAPIKey = true;
  });
};

export const fetchRegenerateAPIKeySuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRegenerateAPIKey = false;
    let index = draft.listUsers.findIndex((user) => user.email === actions.payload.email);
    if (~index) {
      draft.listUsers[index].apiRequestKey = actions.payload.userResponse.apiRequestKey;
    }
  });
};

export const fetchRegenerateAPIKeyFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isRegenerateAPIKey = false;
  });
};

// migrate dids
export const fetchMigrateDidsInUser = (actions, state) => {
  return produce(state, (draft) => {
    draft.isMigratingDids = true;
  });
};

export const fetchMigrateDidsInUserSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isMigratingDids = false;
  });
};

export const fetchMigrateDidsInUserFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isMigratingDids = false;
    draft.errorMigrateDids = actions.error;
  });
};

// add dids
export const fetchAddDidsInUser = (actions, state) => {
  return produce(state, (draft) => {
    draft.isAddingDids = true;
  });
};

export const fetchAddDidsInUserSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isAddingDids = false;
  });
};

export const fetchAddDidsInUserFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isAddingDids = false;
    draft.errorAddingDids = actions.error;
  });
};

// get show dids
export const baseDidInUser = () => {
  return {
    didInUser: {
      listDid: [],
      loading: false,
      error: null,
      isLastItem: false,
    },
  };
};

export const fetchDidInUser = (actions, state) => {
  return produce(state, (draft) => {
    draft.didInUser.loading = true;
  });
};

export const fetchDidInUserSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.didInUser.loading = false;
    draft.didInUser.listDid = actions.data
      ? [...draft.didInUser.listDid, ...actions.data]
      : draft.didInUser.listDid;
    draft.didInUser.isLastItem = actions.isLastItem;
  });
};

export const fetchDidInUserFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.didInUser.loading = false;
    draft.didInUser.error = actions.error;
  });
};

export const fetchClearDidInUser = (actions, state) => {
  return produce(state, (draft) => {
    draft.didInUser = baseDidInUser().didInUser;
  });
};
